import { render } from "./TheUserList.vue?vue&type=template&id=8c1dcd50"
import script from "./TheUserList.vue?vue&type=script&lang=js"
export * from "./TheUserList.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__